import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<void, 'itemRoot'>()(
  ({ tokens }, _, classes) => ({
    formRoot: {
      width: '100%',
    },

    itemBox: {
      '&:last-child': {
        [`& .${classes.itemRoot}`]: {
          borderBottom: 0,
        },
      },
    },

    itemRoot: {
      margin: 0,
      width: '100%',
      border: `${tokens.border.s}px solid`,
      borderColor: tokens.colors.stroke.primary,
      borderLeft: 0,
      borderTop: 0,
      borderRight: 0,
    },

    inputRoot: {
      paddingTop: 0,
      paddingRight: tokens.spacing['2'],
      paddingBottom: 0,
      paddingLeft: tokens.spacing['2'],
      marginRight: tokens.spacing['12'],

      '&:hover, &:hover.Mui-checked': {
        backgroundColor: 'transparent',
      },

      '& .MuiFormControlLabel-root': {
        marginLeft: 0,
        marginRight: 0,
      },

      '& .MuiSvgIcon-root path': {
        fill: tokens.colors.stroke.primary,
      },

      '&.Mui-checked .MuiSvgIcon-root path': {
        fill: tokens.colors.original.brand.primary,
      },
    },
  }),
);
